export const allowedBrandNames = [
  "Al Kazzi",
  "Douaihy",
  "Castania",
  "Feirouz",
  "Shahin",
  "Gandour",
  "Abido",
  "Adida",
  "Chamsine",
  "Moulin D'Or",
  "Sun Bread",
  "Yamama",
  "Chtoura Garden",
  "Chtoura Fields",
  "Al Raii",
  "Al Yaman",
  "Déan Gourmet",
  "Durra",
  "Najjar",
  "Sun Bread",
  "Puck",
  "Indomie",
  "Fromages du Liban"
];
